export var InventoryTransferStatus;
(function (InventoryTransferStatus) {
    InventoryTransferStatus["STAGED"] = "STAGED";
    InventoryTransferStatus["ASSIGNED"] = "ASSIGNED";
    InventoryTransferStatus["IN_TRANSIT"] = "IN_TRANSIT";
    InventoryTransferStatus["DELIVERED"] = "DELIVERED";
    InventoryTransferStatus["CANCELLED"] = "CANCELLED";
})(InventoryTransferStatus || (InventoryTransferStatus = {}));
// Helper functions
export function getTransferStatusColor(status) {
    switch (status) {
        case InventoryTransferStatus.STAGED:
            return 'default';
        case InventoryTransferStatus.ASSIGNED:
            return 'blue';
        case InventoryTransferStatus.IN_TRANSIT:
            return 'orange';
        case InventoryTransferStatus.DELIVERED:
            return 'green';
        case InventoryTransferStatus.CANCELLED:
            return 'red';
        default:
            return 'default';
    }
}
export function getTransferStatusLabel(status) {
    switch (status) {
        case InventoryTransferStatus.STAGED:
            return 'Staged';
        case InventoryTransferStatus.ASSIGNED:
            return 'Assigned';
        case InventoryTransferStatus.IN_TRANSIT:
            return 'In Transit';
        case InventoryTransferStatus.DELIVERED:
            return 'Delivered';
        case InventoryTransferStatus.CANCELLED:
            return 'Cancelled';
        default:
            return status;
    }
}
export function calculateTransitTime(startDate, endDate) {
    if (!startDate || !endDate) {
        return null;
    }
    try {
        const start = new Date(startDate).getTime();
        const end = new Date(endDate).getTime();
        if (isNaN(start) || isNaN(end)) {
            return null;
        }
        const diffMs = end - start;
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        // Format as "Xh Ym" or "Ym" if less than 1 hour
        const formatted = hours > 0
            ? `${hours}h ${minutes}m`
            : `${minutes}m`;
        return { hours, minutes, formatted };
    }
    catch (error) {
        return null;
    }
}
export function getActiveTransitTime(transfer) {
    if (!transfer.dispatchedAt || transfer.deliveredAt || transfer.cancelledAt) {
        return null;
    }
    const dispatched = new Date(transfer.dispatchedAt).getTime();
    const now = new Date().getTime();
    // Return hours
    return (now - dispatched) / (1000 * 60 * 60);
}
//# sourceMappingURL=inventoryTransfer.js.map